import { InboxMenu } from '../components/inbox-menu'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import './../style/inbox.scss'
import { useIntl } from 'react-intl'
import { SwitchAccount } from '../components/switch-account'
import { useEffect, useState } from 'react'
import { getAllEmail, getMailers, getUserInfo } from '../core/_requests'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import { InboxList } from '../components/inbox-list'
import ComposeEmail from '../components/compose-email'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { InboxDetails } from '../components/inbox-details'
import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { Formik } from 'formik'
import { PageTitle } from '../../../../_metronic/layout/core'
import { SharedAccessBreadCrum } from '../core/_constants'
import brandingConfig from '../../../../config/brandingConfig'
// import { NoDataPage } from '../../resources/components/NoDataPage'

export const Inbox = () => {
  const { formatMessage } = useIntl()
  const [connectorLoading, setconnectorLoading] = useState(true)
  const [accountType, setaccountType] = useState('')
  const [isUserConnected, setisUserConnected] = useState(false)
  const { companyId } = useAuth()
  const [userLoading, setuserLoading] = useState(true)
  const [userInfo, setuserInfo] = useState('')
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [emailPerPage, setEmailPerPage] = useState<number>(10)
  const [status, setStatus] = useState('INBOX')
  const [emails, setEmails] = useState<any[]>([])
  const [totalRecords, setTotalRecords] = useState<number>()
  const [totalInboxCount, setTotalInboxCount] = useState<number>()
  const [totalSentCount, setTotalSentCount] = useState<number>()
  const [totalDraftCount, setTotalDraftCount] = useState<number>()
  const [totalTrashCount, setTotalTrashCount] = useState<number>()
  const [totalMarkedCount, setTotalMarkedCount] = useState<number>()
  const [count, setCount] = useState<number>(0)
  const [pageNumbers, setPageNumbers] = useState<number[]>([])
  const [search, setSearch] = useState<string>('')
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const emailId = searchParams.get('id')
  const isStatus = searchParams.get('status')
  const [isNewMessageClicked, setIsNewMessageClicked] = useState<boolean>(false)
  const [starredEmails, setStarredEmails] = useState<{ [key: string]: boolean }>({})
  const [inboxListLoading, setInboxListLoading] = useState<boolean>(true)

  const initialValues = {
    to: '',
    cc: '',
    bcc: '',
    subject: '',
    quillText: '',
    files: [],
  }

  const validateEmails = (value: any) => {
    if (!value) return true
    const emails = value.trim().split(/\s*,\s*/)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const invalidEmails = emails.filter((email: any) => !emailRegex.test(email))
    if (invalidEmails.length > 0) {
      return false
    }
    return true
  }

  const composeEmailSchema = Yup.object().shape({
    to: Yup.string()
      .required('To email is required')
      .test('to-validation', 'Invalid email', validateEmails),
    cc: Yup.string().test('cc-validation', 'Invalid email', validateEmails),
    bcc: Yup.string().test('bcc-validation', 'Invalid email', validateEmails),
    subject: Yup.string(),
    quillText: Yup.string(),
    files: Yup.array(),
  })

  const getMailerInformation = async () => {
    setconnectorLoading(true)
    try {
      const {
        data: { success, data },
      } = await getMailers(companyId!)
      if (success) {
        console.log(data.isNylasActive, 'mailers')

        if (data.isNylasActive === 'nylasGoogle' || data.isNylasActive === 'nylasMicrosoft') {
          setaccountType(data.isNylasActive)
          setisUserConnected(true)
          getUserInformation()
        } else {
          toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
            autoClose: false,
            closeOnClick: true,
          })
        }
      } else {
        toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
          autoClose: false,
          closeOnClick: true,
        })
      }
    } catch (err) {
      toast.info(formatMessage({ id: 'Please connect your Google or Microsoft account' }), {
        autoClose: false,
        closeOnClick: true,
      })
    } finally {
      setconnectorLoading(false)
    }
  }

  const getUserInformation = async () => {
    setuserLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getUserInfo(companyId!)
      if (success) {
        console.log(data, ' data')
        setuserInfo(data.account.data.email)
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setuserLoading(false)
    }
  }

  useEffect(() => {
    getMailerInformation()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getAllMails = async () => {
    setInboxListLoading(true)
    try {
      const {
        data: { success, error, data },
      } = await getAllEmail(
        companyId!,
        currentPage,
        emailPerPage,
        status,
        search,
        'createdAt',
        'DESC'
      )
      if (success) {
        console.log(data, ' dataaa')
        const initialStarredEmails = data.emails.reduce(
          (acc: { [key: string]: boolean }, email: any) => {
            acc[email.emailMessageId] = email.starred // Assuming `isStarred` indicates if an email is starred
            return acc
          },
          {}
        )

        // Update the states
        setStarredEmails(initialStarredEmails)
        setCurrentPage(data.currentPage)
        setEmailPerPage(data.recordsPerPage)
        setTotalRecords(data.totalRecords)
        setTotalInboxCount(data.totalInbox)
        setTotalDraftCount(data.totalDraft)
        setTotalMarkedCount(data.totalMarked)
        setTotalSentCount(data.totalSent)
        setTotalTrashCount(data.totalTrash)
        setEmails(data.emails)
        setCount(data.totalRecords)
      } else {
        toast.error(formatMessage({ id: error }))
      }
    } catch (err) {
      console.log(err)
    } finally {
      setInboxListLoading(false)
    }
  }
  useEffect(() => {
    getAllMails()
  }, [status, currentPage, emailPerPage, search]) // eslint-disable-line

  useEffect(() => {
    const calculatePageNumbers = () => {
      const pages = []
      for (let i = 1; i <= Math.ceil(count / emailPerPage); i++) {
        pages.push(i)
      }
      setPageNumbers(pages)
    }

    calculatePageNumbers()
  }, [count, emailPerPage]) // eslint-disable-line

  console.log(emails, ' all mails')
  console.log(totalRecords, ' totalRecords')

  useEffect(() => {
    const handleTabChange = () => {
      navigate(`${location.pathname}?tab=inbox&status=inbox`)
    }
    handleTabChange()
  }, []) // eslint-disable-line

  const submitStep = () => { }

  return (
    <>
      <PageTitle
        breadcrumbs={SharedAccessBreadCrum}
        description={formatMessage({ id: 'Inbox' })}
      >
        {formatMessage({ id: 'Shared Access' })}
      </PageTitle>
      <div id='kt_app_content' className='app-content flex-column-fluid'>
        <InfoCard2
          title={formatMessage({ id: 'Unifying Communication with Shared Access' })}
          desc={formatMessage({
            id: 'Connect your email account (Google Workspace or Microsoft Office) to manage all your investment-related communications in one place. This integration eliminates the need to switch between platforms and enhances the collaboration experience for fundraising and investor relationship management.',
          })}
          slug={brandingConfig.helpLinks.sharedAccessInbox}
        />
        <div id='kt_app_content_container'>
          <div className='row g-7'>
            <div className='col-xl-3'>
              {/* <ConnectedAccount /> */}
              {/* after connecting the account component commented below should come */}
              <div className='mb-4'>
                <SwitchAccount
                  userInfo={userInfo}
                  isUserConnected={isUserConnected}
                  accountType={accountType}
                  userLoading={userLoading}
                  connectorLoading={connectorLoading}
                />{' '}
              </div>
              <InboxMenu
                status={status}
                setStatus={setStatus}
                totalInboxCount={totalInboxCount}
                totalDraftCount={totalDraftCount}
                totalMarkedCount={totalMarkedCount}
                totalSentCount={totalSentCount}
                totalTrashCount={totalTrashCount}
                setSearch={setSearch}
                setCurrentPage={setCurrentPage}
                setIsNewMessageClicked={setIsNewMessageClicked}
              />
            </div>
            <div className='col-xl-9'>
              {isStatus === 'draft' && emailId ? (
                <Formik
                  validationSchema={composeEmailSchema}
                  initialValues={initialValues}
                  onSubmit={submitStep}
                >
                  {(formik) => {
                    return (
                      <Form id='kt_inbox_reply_form' className='rounded border'>
                        <ComposeEmail
                          userInfo={userInfo}
                          status={status}
                          setStatus={setStatus}
                          setIsNewMessageClicked={setIsNewMessageClicked}
                          isNewMessageClicked={isNewMessageClicked}
                          initialValues={initialValues}
                          formik={formik}
                        />
                      </Form>
                    )
                  }}
                </Formik>
              ) : isStatus === 'message' ? (
                <Formik
                  validationSchema={composeEmailSchema}
                  initialValues={initialValues}
                  onSubmit={submitStep}
                >
                  {(formik) => {
                    return (
                      <Form id='kt_inbox_reply_form' className='rounded border'>
                        <ComposeEmail
                          userInfo={userInfo}
                          status={status}
                          setStatus={setStatus}
                          setIsNewMessageClicked={setIsNewMessageClicked}
                          isNewMessageClicked={isNewMessageClicked}
                          initialValues={initialValues}
                          formik={formik}
                        />
                      </Form>
                    )
                  }}
                </Formik>
              ) : emailId ? (
                <InboxDetails
                  composeEmailSchema={composeEmailSchema}
                  initialValues={initialValues}
                  onSubmit={submitStep}
                  userInfo={userInfo}
                  setEmailStatus={setStatus}
                  emailStatus={status}
                  setStarredEmails={setStarredEmails}
                  starredEmails={starredEmails}
                  getAllMails={getAllMails}
                  emails={emails}
                />
              ) : (
                <InboxList
                  emails={emails}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  status={status}
                  emailPerPage={emailPerPage}
                  count={count}
                  pageNumbers={pageNumbers}
                  totalRecords={totalRecords}
                  setEmailPerPage={setEmailPerPage}
                  search={search}
                  setSearch={setSearch}
                  setStarredEmails={setStarredEmails}
                  starredEmails={starredEmails}
                  getAllMails={getAllMails}
                  inboxListLoading={inboxListLoading}
                  userLoading={userLoading}
                  connectorLoading={connectorLoading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
